import SceButton from "../../../../Common/CommonComponents/sceButton";
import overlayClasses from "./sceOverlayStyle.scss";
import ServiceAccountDetailsComponent from '../Common/serviceAccountDetailsComponent';
import classes from './baTurnOffPopup.scss';
import { getLocalizedStrings } from "../../../centralizedLocalizedString";
import FocusTrap from "focus-trap-react";
import BudaErrorBox from "../Common/budaErrorBox";
const BaTurnOffPopup = (props) => {
    let strings = getLocalizedStrings("BaAlerts");
    let closeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
    let showError = (props.isErrorCard) ? <BudaErrorBox onFormhandler={props.baDeEnrollClick} /> : null;
    return (
        <FocusTrap 
             focusTrapOptions={{
                allowOutsideClick: true,
            }}
            >
        <div tabIndex="0" className={[overlayClasses.sceOverlay, classes.sceSetNotificationsDialog].join(' ')}>
            <div className={overlayClasses.sceOverlayContent}>
                <div ref={props.setWrapper}className={overlayClasses.sceDialogBox}>
                    <div className={classes.textAlignLeft}>
                        <div className='row'>
                            <div className={'col-xs-12 ' + classes.sceSetNotificationMainHeader}>{strings.budaTuroffHeader}<button className={classes.iconClose} onClick={props.handleClose} ><img  src={closeIcon} alt="close Icon" /></button></div>
                            {showError}
                            <div className={'col-xs-12 ' + classes.sceSetNotificationHeader}>{strings.budaturnoffDescription}</div>
                        </div>
                        <ServiceAccountDetailsComponent selectedAccount={props.selectedAccount} />
                        <div className="text-align-center">
                            <div className={classes.footerButton}>
                                <div className={classes.turnOnBtn}>
                                    <SceButton id="budgetAssistantTurnOff" iconType="rightArrow" buttonType="primary" value={strings.budaTurnOffBtn} onClick={props.baDeEnrollClick} />
                                </div>
                            </div>
                            <div className={classes.cancelBtn}>
                                <SceButton id="budgetAssistantCancel" iconType="cancel" buttonType="sceCancel" value={strings.cancelButton} onClick={props.handleClose} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </FocusTrap>
    );
};
export default BaTurnOffPopup;